import { metrics } from '@atlassian/browser-metrics';
import { BMEventsType } from '@atlassian/browser-metrics/types';
export var embeddedViewToEditTransitionMetric = function embeddedViewToEditTransitionMetric() {
  return metrics.interaction({
    key: 'embedded-confluence-view-to-edit-transition'
  });
};
var timings = [{
  key: 'lazy-load',
  startMark: 'lazy-load-start',
  endMark: 'lazy-load-end'
}, {
  key: 'common-load',
  startMark: 'common-load-start',
  endMark: 'common-load-end'
}, {
  key: 'iframe-content-initialized',
  startMark: 'iframe-content-initialized-start',
  endMark: 'iframe-content-initialized-end'
}];
var loadingMetricsConfig = {
  viewPage: {
    key: 'embedded-confluence-view-page-iframe',
    type: BMEventsType.PAGE_SEGMENT_LOAD,
    timings: timings
  },
  editPage: {
    key: 'embedded-confluence-edit-page-iframe',
    type: BMEventsType.PAGE_SEGMENT_LOAD,
    timings: timings
  }
};
export var embeddedConfluenceIframeLoadMetrics = function embeddedConfluenceIframeLoadMetrics(contentType) {
  return metrics.pageSegmentLoad(loadingMetricsConfig[contentType]);
};